<template>
  <transition-group
    name="toast-fade"
    tag="div"
    class="left-0 my-0 mx-auto max-w-[25rem] overflow-hidden absolute right-0 text-center top-4 z-[9999]"
  >
    <woot-snackbar
      v-for="snackMessage in snackMessages"
      :key="snackMessage.key"
      :message="snackMessage.message"
      :action="snackMessage.action"
    />
  </transition-group>
</template>

<script>
import WootSnackbar from './Snackbar.vue';
import alertMixin from 'shared/mixins/alertMixin';

export default {
  components: {
    WootSnackbar,
  },
  mixins: [alertMixin],
  props: {
    duration: {
      type: Number,
      default: 2500,
    },
  },

  data() {
    return {
      snackMessages: [],
    };
  },

  mounted() {
    this.$emitter.on('newToastMessage', this.onNewToastMessage);
  },
  beforeDestroy() {
    this.$emitter.off('newToastMessage', this.onNewToastMessage);
  },
  methods: {
    onNewToastMessage(message, action) {      
      if (message.message === "sla_warning") {
        action = {
          type: 'link',
          to: `/app/accounts/${this.$route.params.accountId}/conversations/${message.action}`,
          message: this.$t('COMMON.VIEW'),
        };
        message = this.$t('NOTIFICATIONS_PAGE.TYPE_LABEL.sla_warning');
      }

      this.snackMessages.push({
        key: new Date().getTime(),
        message,
        action,
      });
      window.setTimeout(() => {
        this.snackMessages.splice(0, 1);
      }, this.duration);
    },
  },
};
</script>
